import { Text } from '../../ui';
import { FlexContainer } from '../../ui/Container';
import { Description } from '../../ui/InputText/style';

const StripeError = () => {
  return (
    <FlexContainer flexDirection="column" padLeft={true} gap="xs">
      <Text color="error">There was an error creating the Stripe Checkout</Text>
      <Description>If the problem persists please contact an admin.</Description>
    </FlexContainer>
  );
};

export default StripeError;
